import React from "react";
import "./App.css";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Link,
	Redirect,
	useLocation,
	useParams,
} from "react-router-dom";
import TableTool from "./container/TableTool";
import SettingTemplateBackend from "./container/SettingTemplateBackend";
import { Grid, makeStyles } from "@material-ui/core";
import NavBar from "./component/NavBar";
import SettingTemplateBackendDetail from "./container/SettingTemplateBackendDetail";

const useStyle = makeStyles((theme) => ({
	root: {
		background: "#152036",
    minHeight : "100vh" 
	},
	navbar: {
		width: 210,
    position : "fixed",
		height: "100vh",
		background: theme.palette.background.default,
	},
	main: {
		padding : 30,
		marginLeft : 250,
		// paddingLeft: 230,
		flex : 1,
		height: "100vh",
	},
}));

function App() {
	const classes = useStyle();
	return (
		<Router>
			<Grid >
				<TransitionGroup>
					<CSSTransition classNames="fade" timeout={300}>
						<Switch>
							<Grid className={classes.root} container direction = "column">
								<Grid className={classes.navbar}>
									<NavBar />
								</Grid>
								<Grid className={classes.main}>
									<Route
										path="/setting-template"
										component={SettingTemplateBackend}
									/>
									<Route path="/setting-table" component={TableTool} />
									<Route path="/setting-template-detail/:templateId/:id" component={SettingTemplateBackendDetail} />
								</Grid>
							</Grid>
						</Switch>
					</CSSTransition>
				</TransitionGroup>
			</Grid>
		</Router>
	);
}

export default App;
